import { render, staticRenderFns } from "./handleDialog.vue?vue&type=template&id=5af8a5f9&scoped=true&"
import script from "./handleDialog.vue?vue&type=script&lang=js&"
export * from "./handleDialog.vue?vue&type=script&lang=js&"
import style0 from "./handleDialog.vue?vue&type=style&index=0&id=5af8a5f9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af8a5f9",
  null
  
)

export default component.exports